export const COLORS = {
  headerColor: "#282C35",
  borderColor: "#ebe9e9",
  primaryColor: "#054752",
  primaryLight500: "#006C6D",
  primaryLight100: "#1B937A",
  secondaryColor: "rgb(61, 72, 93)",
  lightBackgroundColor: "#e8ebeb",
  secondaryTextColor: "rgb(112, 140, 145)",
  primaryTextColor: "rgb(5, 70, 82)",
  lightYellowColor: "#FFFFE0",
  linkColor: "#00b5ff",
  errorColor: "#ff0000d9",
  backgroundBoxColor: "#054752d1",
  backgroundGradient: `linear-gradient( 90deg, rgb(7 30 28) 0%, rgba(5,71,82,1) 60%, rgb(23 104 120) 100% )`,
  gray: "gray",
  // Admin Redesign Tokens
  adminBg: "#F8FAFC",
  adminSidebar: "#0F172A",
  adminCardBg: "#FFFFFF",
  adminAccent: "#38BDF8",
  adminWarning: "#F59E0B",
  adminError: "#EF4444",
  adminSuccess: "#10B981",
  adminTextPrimary: "#1E293B",
  adminTextSecondary: "#64748B",
  adminSidebarHover: "rgba(255, 255, 255, 0.1)",
  adminShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
};
